import { useMatches } from "react-router";

import { getActiveCategorySlug } from "~/feature/categories/utils/getActiveCategorySlug";

export const useActiveCategorySlug = (): string | null => {
  const matches = useMatches();

  return getActiveCategorySlug(matches);
};
